module.exports = __webpack_public_path__ + "img/oth4.17209875.png";